import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const images = [
    '/assets/homepage images/school.png',
    '/assets/homepage images/students1.jpg',
    '/assets/homepage images/students2.jpg'
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <div className="home">
      {/* Hero Section with Image Carousel */}
      <section className="hero-section">
        <div className="image-carousel">
          {images.map((image, index) => (
            <div
              key={index}
              className={`carousel-slide ${index === currentImageIndex ? 'active' : ''}`}
            >
              <img 
                src={image} 
                alt={`Millennium Model School ${index === 0 ? 'School' : 'Students'}`}
                className="carousel-image"
              />
            </div>
          ))}
        </div>
        <div className="hero-overlay"></div>
        <div className="carousel-indicators">
          {images.map((_, index) => (
            <span
              key={index}
              className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
              onClick={() => setCurrentImageIndex(index)}
            ></span>
          ))}
        </div>
        <div className="hero-content">
          <h1 className="hero-title">Welcome to Millennium Model School</h1>
          {/* <p className="hero-subtitle">Empowering minds, shaping futures with excellence in education</p> */}
          <div className="hero-buttons">
            {/* <a href="#about" className="btn btn-primary">Learn More</a> */}
            {/* <a href="/contact-us" className="btn btn-secondary">Contact Us</a> */}
          </div>
        </div>
      </section>

      {/* Features Section - Commented Out */}
      {/* <section className="features-section">
        <div className="container">
          <h2 className="section-title">Why Choose Us</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📚</div>
              <h3>Quality Education</h3>
              <p>Comprehensive curriculum designed to foster critical thinking and academic excellence</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">👨‍🏫</div>
              <h3>Experienced Faculty</h3>
              <p>Dedicated and qualified teachers committed to student success</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🏆</div>
              <h3>Academic Excellence</h3>
              <p>Consistent track record of outstanding results and achievements</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🌱</div>
              <h3>Holistic Development</h3>
              <p>Focus on overall growth including academics, sports, and character building</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🏫</div>
              <h3>Modern Facilities</h3>
              <p>Well-equipped classrooms and infrastructure for optimal learning</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🤝</div>
              <h3>Community Focus</h3>
              <p>Building strong relationships with students, parents, and the community</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* About Preview Section */}
      <section id="about" className="about-preview-section">
        <div className="container">
          <div className="about-content">
            <div className="about-title">
              <h2>About Millennium Model School</h2>
            </div>
            <div className="about-text">
              <p>
                Millennium Model School is committed to providing quality education that 
                nurtures young minds and prepares them for a successful future. We believe 
                in creating an environment where students can explore, learn, and grow.
              </p>
              <p>
                Our mission is to empower students with knowledge, skills, and values that 
                will help them excel in all aspects of life. With a dedicated team of 
                educators and modern facilities, we strive to make learning an enriching 
                experience.
              </p>
              <a href="/about-us/mission-vision" className="btn btn-outline">Learn More</a>
            </div>
          </div>
        </div>
      </section>

      {/* Notice Board Section */}
      <section id="notices" className="notice-board-section">
        <div className="container">
          <h2 className="section-title">Notice Board</h2>
          <div className="notice-board-container">
            <div className="notice-board">
              <div className="notice-item">
                <div className="notice-header">
                  <div className="notice-date">Nov 28, 2025</div>
                  
                </div>
                <div className="notice-content">
                  <div style={{display: "flex", alignItems: "center", marginBottom: "15px", gap: "15px"}}>
                    <h3>Half Yearly Exams 2025</h3>
                    <button className="btn-view" onClick={(e) => e.preventDefault()}>
                      View
                    </button>
                  </div>
                  <p>Half Yearly Examinations for the academic year 2025 are scheduled to commence from 8th December 2025. All students are requested to prepare accordingly.</p>
                </div>
              </div>
              <div className="notice-item">
                <div className="notice-header">
                  <div className="notice-date">Nov 27, 2025</div>
                </div>
                <div className="notice-content">
                <div style={{display: "flex", alignItems: "center", marginBottom: "15px", gap: "15px"}}>
                    <h3>School's New Website</h3>
                    <button className="btn-view" onClick={(e) => e.preventDefault()}>
                      View
                    </button>
                  </div>
                  <p>We are pleased to announce the launch of our new website. Stay updated with all school activities, notices, and important information through our online platform.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Links Section */}
      <section className="quick-links-section">
        <div className="container">
          <h2 className="section-title">Quick Links</h2>
          <div className="quick-links-grid">
            
            <a href="/academics/fee-structure" className="quick-link-card">
              <h3>Fee Structure</h3>
              <p>Transparent fee information</p>
            </a>
            <a href="/academics/school-timings" className="quick-link-card">
              <h3>School Timings</h3>
              <p>View our schedule</p>
            </a>
            <a href="/academics/books" className="quick-link-card">
              <h3>Books</h3>
              <p>Books for current session</p>
            </a>
            <a href="/about-us/faculties" className="quick-link-card">
              <h3>Our Faculty</h3>
              <p>Meet our teachers</p>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;

